<template>
  <div>
    <ul style="margin: 0; padding-left: 0">
      <div v-for="article in news" :key="article._id" class="actualite">
        <div class="actualite__header">
          <div class="actualite__header__title">{{ article.title }}</div>
          <div class="actualite__header__date">
            {{ article.date | formatDateFormat("YYYY-MM-DD") }}
          </div>
        </div>

        <div class="actualite__body">
          <vue-markdown :source="article.content" :anchorAttributes="anchorAttributes" />
        </div>
      </div>

      <template v-if="news.length === 0">
        <div class="actualite">
          <div class="actualite__body">
            <p>Aucun article pour le moment</p>
          </div>
        </div>
      </template>
    </ul>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import _ from 'lodash';

  export default {
    name: 'home-news',
    props: {
      type: {
        type: String
      }
    },
    data() {
      return {
        anchorAttributes: {
          target: '_blank'
        }
      };
    },
    computed: {
      ...mapGetters('config', {
        _news: 'articles'
      }),
      news() {
        return _.filter(this._news, n => n.type === this.type);
      }
    }
  };
</script>

<style lang="scss">
ul {
  margin-left: 0;
  padding-left: 0;
}

.actualite {
  &:not(:first-child) {
    border-top: 2px solid #ebebeb;
    padding-top: 20px;
  }

  &__header {
    display: flex;
    flex-direction: row;
    color: #b1661b;
    font-family: Georgia, "Times New Roman", Times, serif;
    position: relative;

    &__title,
    &__date {
      font-size: 1rem;
      color: #b1661b;
      font-family: Georgia, "Times New Roman", Times, serif;
    }

    &__date {
      text-align: right;
      position: absolute;
      right: 0;
    }
  }

  &__body {
    padding: 20px 0px;
    color: black;

    p {
      width: 100% !important;
      padding-bottom: 10px;
      margin-bottom: 0px;
      text-align: unset;
    }
  }
}
</style>
